import React from "react";

const StarIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4979 5.20944L13.9941 5.27066L13.4979 5.20944C13.4901 5.27259 13.46 5.3342 13.4086 5.38296L10.7768 7.88327L11.1212 8.24576L10.7768 7.88327C10.5571 8.09199 10.4467 8.3928 10.4861 8.69714L10.9235 12.0727C10.9485 12.2657 10.8071 12.4678 10.5684 12.4968C10.4794 12.5076 10.3899 12.4909 10.313 12.4504L7.53237 10.9869C7.18929 10.8063 6.77813 10.8012 6.43066 10.9729L3.54976 12.3968C3.37945 12.481 3.18109 12.4091 3.10453 12.264C3.07638 12.2106 3.06659 12.1516 3.0751 12.0943L3.30535 10.5456C3.39309 9.95551 3.77333 9.43596 4.33534 9.15943L7.53506 7.5851C7.8644 7.42306 8.01163 7.01818 7.83304 6.67814C7.69812 6.42123 7.41788 6.28719 7.14284 6.32514L3.22959 6.86516C2.76399 6.92941 2.29394 6.80222 1.93308 6.5185L0.629671 5.49368C0.477109 5.37373 0.458741 5.16795 0.577226 5.02677L0.202361 4.71216L0.577226 5.02677C0.634809 4.95816 0.72068 4.91023 0.818986 4.89804L4.16055 4.48369C4.533 4.43751 4.86519 4.21438 5.04076 3.87747L6.72445 0.646684C6.78939 0.522074 6.96117 0.457501 7.11063 0.530467C7.16647 0.557734 7.20842 0.600203 7.23309 0.64855L8.82318 3.76427C9.03149 4.17246 9.4339 4.44337 9.88619 4.49565L13.2159 4.88053C13.4073 4.90265 13.516 5.06234 13.4979 5.20944Z"
      fill="url(#paint0_linear_49_12397)"
      stroke="#E58C0D"
    />
    <defs>
      <linearGradient
        id="paint0_linear_49_12397"
        x1="9.91667"
        y1="3.69924"
        x2="3.35746"
        y2="12.9811"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCF18" />
        <stop offset="1" stopColor="#FF9415" />
      </linearGradient>
    </defs>
  </svg>
);

export default StarIcon;
